import React from "react";
import Logo from "../../images/Avanse-Education-Loans-Logo.png";
import { MenuUnfoldOutlined } from "@ant-design/icons";
import { Col, Row } from "react-bootstrap";
import { Drawer, Popover } from "antd";
import { NavLink as Link } from "react-router-dom";

import PartnerLogo from "../../images/Partner-Managment.png";
import AccessLogo from "../../images/Access-Management.png";
import { useState } from "react";
import Logout from "../../containers/Pages/Login/Logout";
import { connect } from "react-redux";
import ChangePassword from "../../containers/Pages/Login/ChangePassword";
import Dashboardlogo from "../../images/Dashboardlogo.png";
import padlock from "../../images/lock.png";
import { HomeOutlined } from "@ant-design/icons";

function LeadMobileHeader(props) {
  const [mobileMenu, setMobileMenu] = React.useState(false);
  const roleType = props.userDetail?.loggedInRoleType;

  const [open, setOpen] = useState(false);
  const hide = () => {
    setOpen(false);
  };
  const handleOpenChange = (newOpen) => {
    setOpen(newOpen);
  };

  const handleMobileMenu = () => {
    setMobileMenu(!mobileMenu);
  };

  const onClose = () => {
    setMobileMenu(false);
  };

  const adminFirstName = (adminName) => {
    if (adminName) return adminName?.toUpperCase()?.charAt(0);
    else return null;
  };

  const adminLastName = (adminLast) => {
    if (adminLast) return adminLast?.toUpperCase()?.charAt(0);
    else return null;
  };

  return (
    <div className="cet-mobile-header">
      <Row className="side-br-mob">
        <Col xs={2}>
          <button
            className="hamburger-icon"
            type="primary"
            onClick={handleMobileMenu}
          >
            <MenuUnfoldOutlined />
            {/* <MenuFoldOutlined />
             */}
          </button>
        </Col>
        <Col xs={7}>
          <div className="log-avs">
            <img src={Logo} alt="" width={100} height={40} />
          </div>
        </Col>
        <Col xs={3} className="cet-mobile-header-login">
          <div className="login-profie">
            <Popover
              color={"white"}
              content={
                <div>
                  <h4>{props.userDetail?.userName}</h4>
                  <h5 className="mb-3">{props.userDetail?.roleName}</h5>
                  <ChangePassword hide={hide} />
                  <Logout hide={hide} />
                </div>
              }
              placement="bottomRight"
              trigger="click"
              open={open}
              onOpenChange={handleOpenChange}
            >
              <div className="img-sec-mobile">
                <h2>
                  {adminFirstName(
                    props.userDetail?.firstName ??
                      props.userDetail?.userName?.split(" ")[0]?.trim()
                  )}
                </h2>
                <h2>
                  {adminLastName(
                    props.userDetail?.lastName ??
                      props.userDetail?.userName?.split(" ")[1]?.trim()
                  )}
                </h2>
              </div>
              {/* <img className="iconLog" src={AdminProfile} alt="" /> */}
            </Popover>
          </div>
        </Col>
      </Row>

      <Drawer
        open={mobileMenu}
        onClose={onClose}
        placement="left"
        width={300}
        className="cet-mobile-header-drawer"
      >
        <div className="log-avs">
          <img src={Logo} alt="" />
        </div>
        <div className="list-contnt">
          <ul className="list">
            <li className="" onClick={onClose}>
              <Link
                className="ListItem"
                to="/leadManagementDashboard/Dashboard"
              >
                <HomeOutlined
                  className="sidebarIcon mx-3"
                  style={{ fontSize: "24px", color: "white" }}
                />
                <span className="list-Text">Home</span>
              </Link>
            </li>
            {(roleType == "PARTNER" || roleType == "POU") && (
              <li className="">
                <Link className="ListItem " to={"AdvancedDashboard"}>
                  <img src={Dashboardlogo} alt="" className="sidebarIcon" />
                  <span className="list-Text">Advanced DashBoard</span>
                </Link>
              </li>
            )}

            <li onClick={onClose}>
              <Link
                className="ListItem"
                to={
                  props.partnerFirmDetails?.partnerFirmStatus ===
                    "FOR_VERIFICATION" ||
                  props.partnerFirmDetails?.partnerFirmStatus ===
                    "ESIGN_PENDING" ||
                  props.partnerFirmDetails?.partnerFirmStatus === "APPROVED"
                    ? `/leadManagementDashboard/viewPartner`
                    : `/PartnerDashBoard/EngagementDetails`
                }
              >
                <img src={AccessLogo} alt="" className="sidebarIcon" />
                <span className="list-Text"> Firm Details</span>
              </Link>
            </li>

            {props?.partnerFirmDetails?.partnerFirmStatus === "NEW_PARTNER" ? (
              <li onClick={onClose} className="ListItem new">
                <img src={PartnerLogo} alt="" className="sidebarIcon" />

                <span className="list-Text"> Lead Management</span>
                <img src={padlock} alt="" className="sidebarIcon-loc" />
              </li>
            ) : (
              <li className="" onClick={onClose}>
                <Link
                  className="ListItem"
                  to="/leadManagementDashboard/leadManagement"
                >
                  <img src={PartnerLogo} alt="" className="sidebarIcon" />
                  <span className="list-Text"> Lead Management</span>
                </Link>
              </li>
            )}
          </ul>
        </div>
      </Drawer>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    checkLogin: state?.auth?.checkLogin,
    firmId:
      state.auth?.checkLogin?.partnerFirmId ||
      state?.auth?.loginCredentials?.data?.partnerFirmDetails?.partnerFirmId ||
      sessionStorage.getItem("cetFirmId"),
    userDetail: state.auth?.userData,
    partnerFirmDetails:
      state?.auth?.partnerFirmDetails ||
      state?.auth?.checkLogin?.partnerFirmDetails,
  };
};

export default connect(mapStateToProps)(LeadMobileHeader);
